import React from 'react';
import classNames from 'classnames';
import { CTALink } from "../../ui/CTA";
import { CTASizes } from "../../ui/CTA/types";
import styles from './ProductLink.module.scss';
const ProductLink = ({ title, pdpUrl, children, className, linkClickCallback, tabindex, ariaStatus, useSimpleLink = false, shouldTruncateProductTitle = true, descriptionFontSize, isProductTileDetailsCentreAligned = false, shouldUnderlineTitleOnHover = true, productLinkDisabled = false, size, }) => {
    const handleClick = (e) => {
        if (linkClickCallback) {
            linkClickCallback(e);
        }
    };
    const propsSetup = {
        'aria-hidden': ariaStatus,
        tabindex,
        href: pdpUrl,
        title,
        onClick: handleClick,
        className: classNames(useSimpleLink ? styles.productLinkSimple : styles.productLink, !shouldTruncateProductTitle && styles.wrap, isProductTileDetailsCentreAligned && styles.productLinkCentreAligned, !shouldUnderlineTitleOnHover && styles.noHoverUnderline, productLinkDisabled && styles.productLinkDisabled, className),
        size: size || descriptionFontSize,
    };
    return useSimpleLink ? (React.createElement("a", Object.assign({}, propsSetup), children)) : (React.createElement(CTALink, Object.assign({ Tag: "a" }, propsSetup), children));
};
export default ProductLink;
//# sourceMappingURL=ProductLink.js.map